<script lang="ts">
  import ModalPictureTextAction from '$components/modal-picture-text-action/ModalPictureTextAction.svelte';
  import { closeModal } from '$components/bottom-sheet/index.svelte';
  import Button from '$components/button/Button.svelte';
  import IconIosSystemShareIcon from '$lib/icons/IconIosSystemShareIcon.svelte';
  import Image from '$lib/assets/banner-add-to-home-screen-ios.webp';
  import platform from 'platform';

  let bannerImage: string = Image;

  let browserName: string = 'Safari Browser';

  if (platform.name === 'Chrome Mobile') {
    browserName = 'Chrome Browser';
  }
</script>

<ModalPictureTextAction titleTestId="pwa-title-text" paragraphTestId="pwa-paragraph-text">
  {#snippet image()}
    <img src={bannerImage} alt="Metri" class="mx-auto w-full" />
  {/snippet}
  {#snippet title()}
    Add Metri to your Home Screen
  {/snippet}
  {#snippet paragraph()}
    To add Metri to your Home Screen, tap the <IconIosSystemShareIcon
      class="relative -top-0.5 inline h-5! grayscale" /> icon in the {browserName} and then “Add to Home
    Screen"
  {/snippet}
  {#snippet action()}
    <Button ariaLabel="Close" stretched variant="secondary" onclick={closeModal}>Close</Button>
  {/snippet}
</ModalPictureTextAction>
